import { useContext } from 'react';
import AvailabilityAction from '~/constants/availabilityAction';
import {
  UserVehicleContext,
  useVehicleAvailability
} from '~/context/vdp/UserVehicleContext';

export default function useIsAvailabilityDisabled() {
  const { isLoaded } = useContext(UserVehicleContext).vehicleAvailability;
  const { action } = useVehicleAvailability();

  return (
    isLoaded &&
    (action === AvailabilityAction.GetStartedDisabled ||
      action === AvailabilityAction.PreOrderNowDisabled)
  );
}
